"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPioneersNegative = function SvgBPioneersNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M37.706 105.113a2.097 2.097 0 01-1.482-.615L24.466 92.76a2.097 2.097 0 112.964-2.964l11.737 11.737a2.097 2.097 0 01-1.482 3.579h.02z"
  }), (0, _core.jsx)("path", {
    d: "M14.994 130.774a2.097 2.097 0 01-1.482-3.579l47.345-47.352a2.098 2.098 0 012.964 2.971l-47.345 47.345a2.095 2.095 0 01-1.482.615zM141.602 103.33a2.097 2.097 0 01-1.482-.615l-15.057-15.057-11.736 11.737a2.098 2.098 0 01-2.971-2.964l13.218-13.247a2.097 2.097 0 011.49-.608 2.097 2.097 0 011.46.608l16.54 16.546a2.097 2.097 0 01-1.483 3.58l.021.02zM2.796 103.33a2.097 2.097 0 01-1.482-3.586l16.56-16.56a2.097 2.097 0 012.964 2.964l-16.56 16.567a2.097 2.097 0 01-1.482.615zM72.217 125.07a5.376 5.376 0 01-3.824-1.58l-9.388-9.387-2.796 2.796a5.369 5.369 0 01-3.782 1.544 5.41 5.41 0 01-3.824-1.593l-4.194-4.25a2.097 2.097 0 112.971-2.957l4.194 4.25c.228.229.537.357.86.356.32 0 .628-.128.853-.356l4.257-4.236a2.097 2.097 0 012.964 0l10.87 10.87c.474.47 1.238.47 1.712 0l10.926-10.856a2.097 2.097 0 012.964 0l4.194 4.194c.481.46 1.239.46 1.72 0l10.017-10.045a2.097 2.097 0 012.964 2.964L95.837 116.85a5.417 5.417 0 01-7.69 0l-2.712-2.72-9.437 9.374a5.369 5.369 0 01-3.781 1.566z"
  }), (0, _core.jsx)("path", {
    d: "M129.425 130.774a2.097 2.097 0 01-1.489-.615L70.728 72.944a2.095 2.095 0 01-.615-1.482V14.414a2.097 2.097 0 114.194 0v56.188l56.621 56.621a2.097 2.097 0 01-1.482 3.58l-.02-.029zM107.84 10.982a18.643 18.643 0 01-11.325-3.824 14.442 14.442 0 00-11.1-2.796L72.551 6.494a2.098 2.098 0 01-.699-4.138L84.715.259a18.65 18.65 0 0114.337 3.586 14.449 14.449 0 0014.19 1.894l7.76-3.153a2.097 2.097 0 111.573 3.887l-7.78 3.153a18.468 18.468 0 01-6.956 1.356z"
  }), (0, _core.jsx)("path", {
    d: "M107.84 44.039a18.643 18.643 0 01-11.325-3.824 14.414 14.414 0 00-11.1-2.796l-2.88.475a2.098 2.098 0 01-.7-4.138l2.88-.475a18.636 18.636 0 0114.337 3.579 14.428 14.428 0 0014.19 1.915l6.474-2.621V4.53a2.097 2.097 0 014.194 0v33.036c-.001.855-.521 1.624-1.314 1.943l-7.801 3.132a18.468 18.468 0 01-6.956 1.398z"
  })));
};

var _default = SvgBPioneersNegative;
exports["default"] = _default;